import React, { useState, useEffect, useMemo } from 'react'
import ErrorModal from '../../../ErrorModal'
import EventsService from '../../../../services/events-service'
import { submitFromlessApplication } from '../../../../utils/formless-utils'
import { fireReactGAEvent } from '../../../Questions/utils'
import { FormlessJourneyProps } from '../FormlessJourney'
import { buildRedirectUrl } from '../../../../utils/url-utils'
import FormlessJourneyV3InterstitialWrapper from './Interstitial/FormlessJourneyV3InterstitialWrapper'

export const FormlessJourneyV3Wrapper = ({
  experimentName,
  attribution,
  submissionResponse,
  isPreapproved = false,
  eventsServiceUrl,
  appFormEventParams,
  mappedApplication,
  lenderDetails
}: FormlessJourneyProps): JSX.Element => {
  const [apiError, setApiError] = useState(false)
  const [response, setResponse] = useState(submissionResponse)
  const eventsService = appFormEventParams && EventsService(eventsServiceUrl, appFormEventParams)

  useEffect(() => {
    if (!response?.success) {
      const id = setTimeout(() => setApiError(true), 3000)
      return () => clearTimeout(id)
    }
  }, [response])

  const redirectUrl = useMemo(
    () => buildRedirectUrl(response, isPreapproved),
    [response, isPreapproved]
  )

  const closeError = async () => {
    if (mappedApplication && eventsService) {
      setApiError(false)
      const resp = await submitFromlessApplication({
        application: mappedApplication,
        eventsService,
        isRetry: true
      })
      fireReactGAEvent({
        category: 'Application Form',
        action: 'Submit',
        label: resp.success ? 'Success' : 'Unsuccessful'
      })
      setResponse(resp)
    }
  }

  return (
    <>
      {apiError && (
        <ErrorModal
          titleText="Sorry"
          ctaText="Please try again"
          onClick={closeError}
        >
          There was a problem submitting your application
        </ErrorModal>
      )}

      {!apiError && attribution && (
        <FormlessJourneyV3InterstitialWrapper
          source={attribution.source}
          experimentName={experimentName}
          isPreapproved={isPreapproved}
          lenderDetails={lenderDetails}
          redirectUrl={redirectUrl}
          eventsServiceUrl={eventsServiceUrl}
          appFormEventParams={appFormEventParams}
        />
      )}
    </>
  )
}
